// extracted by mini-css-extract-plugin
export default {"container":"UK-z","topReviewHeading":"VK-z","criticalReview":"WK-z","favorableReview":"XK-z","vsSeparator":"YK-z"};